import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropTypes from "prop-types";
import CustomPropTypes from '../../utils/customPropTypes';
import ImageBlock from '../ImageBlock';
import SafeHTML from '../SafeHTML';
import GenericCarousel from '../../../scss/components/GenericCarousel';
import AllProducts from '../../../scss/components/Products/AllProducts';
import style from '../../../scss/components/Products/ProductCarousel';
import DeviceView from "../DeviceView";
import ButtonLink from '../ButtonLink';
import ProductCard from "./ProductCard";
export default class ProductCarousel extends Component {
    static propTypes = {
        eyebrow: PropTypes.string,
        description: PropTypes.string,
        allProducts: PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
        }),
        products: PropTypes.arrayOf(CustomPropTypes.Product)
    }
    constructor(props) {
        super(props);
        this.state = { isLastSlide: false, isFirstSlide: true };
    }
    setStateForActiveSlides = (currentIndex, slideToShow) => {
        this.setState({
            isFirstSlide: (currentIndex == 0),
            isLastSlide: (currentIndex == (this.props.products.length - slideToShow))
        })
    }
    getProductCardList = (maxItems) => {
        let items = this.props.products;
        if (items && items.length > 0) {
            return items.map(function (objProduct, index) {
                if (maxItems != -1 && (index + 1) > maxItems)
                    return null;
                return (<div key={index} className="post-carousel-items">
                    <ProductCard product={objProduct}></ProductCard>
                </div>);
            });
        }
        else
            return null;
    }
    nextSlide() {
        this.refs.slider.slickNext();
    }
    prevSlide() {
        this.refs.slider.slickPrev();
    }
    getSliderSettings = () => {
        var self = this;
        return {
            className: "post-carousel-items",
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            infinite: false,
            arrows: false,
            afterChange: function (index) {
                self.setStateForActiveSlides(index, 3);
            }
        }
    }
    getSliderButtons = () => {
        if (this.props.products && this.props.products.length > 3) {
            return <>
                <a onClick={() => { this.prevSlide() }} className={"btn btn-circle" + (this.state.isFirstSlide ? " disabled" : "")}><i className="icon icon-prev"></i></a>
                <a onClick={() => { this.nextSlide() }} className={"btn btn-circle" + (this.state.isLastSlide ? " disabled" : "")}><i className="icon icon-next"></i></a>
            </>
        }
        else
            return null;
    }
    render() {

        return (
            <div className="product-carousel-section">
                <div className="container">
                    <div className="post-carousel">
                        <div className="post-carousel-head">
                            <div className="post-info" >
                                <h2 className="hunterlab-title post-info-title">{this.props.eyebrow}</h2>
                                <div className="post-info-desc"><SafeHTML>{this.props.description}</SafeHTML></div>
                            </div>
                            <DeviceView deviceType={DeviceView.DeviceTypes.Desktop}>
                                <div className="post-info-action">
                                    <ButtonLink className="link-action" text={"查看" + this.props.allProducts.title} url={this.props.allProducts.url} />
                                    {this.getSliderButtons()}
                                </div>
                            </DeviceView>
                        </div>
                        <DeviceView deviceType={DeviceView.DeviceTypes.Desktop}>
                            <Slider ref="slider" {...this.getSliderSettings()}>
                                {this.getProductCardList(-1)}
                            </Slider>
                        </DeviceView>
                        <DeviceView deviceType={DeviceView.DeviceTypes.Mobile}>
                            {this.getProductCardList(3)}
                        </DeviceView>
                        <div className="post-carousel-action">
                            <ButtonLink className="link-action" text={"See " + this.props.allProducts.title} url={this.props.allProducts.url} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}